<template>
  <div class="articlePage pageWhite pagePadding">
    <div class="articleScreen" ref="screenWrap">
      <el-form :model="screenForm" inline ref="screenForm" small>
        <el-form-item label="标题" prop="title">
          <el-input v-model="screenForm.title"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="toSubmitScreen">查询</el-button>
          <el-button size="small" @click="toResetScreen">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="articleTable" :style="`height: ${tableHeight}px;`">
      <el-table :data="tableData" stripe header-row-class-name="table-header-bg" border
                :max-height="tableHeight" v-loading="isGetting">
        <el-table-column type="index" width="70" label="序号">
          <template slot-scope="scope">{{(currentPage - 1) * 20 + scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="标题" min-width="150" show-overflow-tooltip prop="title"></el-table-column>
        <el-table-column label="指南" min-width="80">
          <template slot-scope="{row}">
            <el-switch v-model="row.isBanner" @change="toggle(row.id)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" min-width="155" prop="createTime"></el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="primary" plain @click="toEdit(scope.row.id)">修改</el-button>
            <el-button size="small" type="danger" plain @click="toDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="articleFooter">
      <div class="tableSelect">
        <el-button type="primary" size="mini" @click="toAdd">新增通知</el-button>
      </div>
      <el-pagination background @current-change="currentChange" :pager-count="5" :total="totalSize" :page-size="20"
                     layout="total,prev,pager,next,jumper" :current-page="currentPage"></el-pagination>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    data () {
      return {
        screenWrap: 50,
        totalSize: 0,
        currentPage: 1, // 当前页码
        tableData: [],
        isGetting: false,
        screenForm: {
          title: ''
        },
        toScreenForm: {}
      }
    },
    computed: {
      tableHeight () {
        return window.innerHeight - 142 - this.screenWrap
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.screenWrap = this.$refs.screenWrap.offsetHeight
      })
    },
    created () {
      this._toGetList()
    },
    methods: {
      _toGetList (page) {
        this.isGetting = true
        this.currentPage = page || 1
        this.toScreenForm['page'] = this.currentPage
        this.toScreenForm['size'] = 20
        this.$api.getNoticeList(this.toScreenForm, (res) => {
          this.tableData = res.records
          this.totalSize = +res.total
        }, () => {
          this.isGetting = false
        })
      },
      toSubmitScreen () {
        this.toScreenForm = JSON.parse(JSON.stringify(this.screenForm))
        this._toGetList()
      },
      toResetScreen () {
        this.$refs['screenForm'].resetFields()
        this.toScreenForm = {}
        this._toGetList()
      },
      currentChange (v) { // 分页点击
        this._toGetList(v)
      },
      toggle (id) {
        this.$api.toggleNotice(id, () => {
          this.$message.success('切换成功')
        }, () => {
          this._toGetList(this.currentPage)
        })
      },
      toAdd () {
        this.$router.push({name: 'noticeAction'})
      },
      toEdit (id) {
        this.$router.push({name: 'noticeActionEdit', params: {id}})
      },
      toDel (id) {
        this.$confirm('确定要删除此通知吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.$api.delNotice(id, () => {
            this.$message.success('删除成功')
            this._toGetList(this.currentPage)
          })
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/notice.vue